import { render, staticRenderFns } from "./MedicineMngtDtlReg.vue?vue&type=template&id=3862e7fe"
import script from "./MedicineMngtDtlReg.vue?vue&type=script&lang=js"
export * from "./MedicineMngtDtlReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports